import { useState } from 'react';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth';
import { auth } from '../firebase.js';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mode, setMode] = useState('signin');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      if (mode === 'signin') await signInWithEmailAndPassword(auth, email, password);
      else await createUserWithEmailAndPassword(auth, email, password);
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  const google = async () => {
    setBusy(true);
    setErr(null);
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <form onSubmit={submit} className="w-80 space-y-3 rounded border border-border bg-panel p-6">
        <h1 className="text-xl font-semibold">👁️ Phantom Track</h1>
        <input
          type="email" required placeholder="email"
          value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded bg-zinc-800 px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-zinc-500"
        />
        <input
          type="password" required placeholder="password" minLength={6}
          value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded bg-zinc-800 px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-zinc-500"
        />
        <button
          type="submit" disabled={busy}
          className="w-full rounded bg-zinc-100 px-3 py-2 text-sm font-medium text-black disabled:opacity-50"
        >
          {mode === 'signin' ? 'Sign in' : 'Create account'}
        </button>
        <button
          type="button" onClick={google} disabled={busy}
          className="w-full rounded border border-border px-3 py-2 text-sm"
        >
          Continue with Google
        </button>
        <button
          type="button"
          onClick={() => setMode((m) => (m === 'signin' ? 'signup' : 'signin'))}
          className="w-full text-center text-xs text-zinc-400 hover:text-zinc-200"
        >
          {mode === 'signin' ? "Don't have an account? Create one" : 'Have an account? Sign in'}
        </button>
        {err && <div className="text-xs text-red-400">{err}</div>}
      </form>
    </div>
  );
}
